
import Vue from "vue"
import Component from "vue-class-component"
import {date, QDate, QPopupProxy} from "quasar"
import {Prop} from "vue-property-decorator"
import _ from "lodash"

@Component({components: {QPopupProxy, QDate}})
export default class PopupDate extends Vue {
  @Prop()
  label: string

  @Prop()
  value: string

  @Prop({default: false})
  optional: boolean

  // forces the label into its floated/stacked position at all times, useful
  // when aligning against a sibling field whose label is always floated
  @Prop({default: false})
  stackLabel: boolean

  $refs: {
    qDateProxy: QPopupProxy
  }

  get date(): string {
    return this.value
  }

  set date(value: string) {
    this.$emit("input", this.clampToToday(value))
  }

  // snaps a fully-formed date back to today when it falls in the future,
  // rather than just flagging it as invalid
  private clampToToday(v: string): string {
    if (_.isEmpty(v) || !this.isValidFormat(v)) return v
    const parsed = this.parse(v)
    const today = new Date()
    return parsed != null && parsed > today ? date.formatDate(today, "DD/MM/YYYY") : v
  }

  private parse(ddmmyyyy: string | null): Date | null {
    if (_.isEmpty(ddmmyyyy)) return null
    const extracted = date.extractDate(<string>ddmmyyyy, "DD/MM/YYYY")
    return Number.isNaN(extracted.getTime()) ? null : extracted
  }

  // treats a value as blank if it has no digits at all - guards against mask
  // remnants (e.g. stray "/" separators) left behind after focusing/clearing
  // a field without ever typing a full date
  private isBlank(v: string | null | undefined): boolean {
    return _.isEmpty(v) || !/\d/.test(<string>v)
  }

  private isValidFormat(v: string): boolean {
    return /^([0-2]\d|(3)[01])(\/)(((0)\d)|((1)[0-2]))(\/)\d{4}$/.test(v)
  }

  private isNotAfterToday(v: string): boolean {
    const parsed = this.parse(v)
    return parsed == null || parsed <= new Date()
  }

  private dateRuleX = (v: string): boolean | string =>
    (this.optional && this.isBlank(v)) ||
    (this.isValidFormat(v) && this.isNotAfterToday(v)) ||
    "Invalid date"

  dateRule = (v: string) =>
    _.isEmpty(v) || /^([0-2]\d|(3)[01])(\/)(((0)\d)|((1)[0-2]))(\/)\d{4}$/.test(v)

  private dateOptions = (queryDate: string): boolean => {
    const parsed = date.extractDate(queryDate, "YYYY/MM/DD")
    return parsed <= new Date()
  }
}
